import { useState, Dispatch, SetStateAction, useEffect, useCallback } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { Box, Typography} from '@mui/material';
import { Formik, Form} from 'formik';
import { useParams } from 'react-router-dom';

import { NotificationInner } from './NotificationInner';

import { notificationType } from '../../../types/notifications';
import { getVoucherNotification } from '../../../../src/graphql/queries';
import { createVoucherNotificationTable, updateVoucherNotificationTable } from '../../../graphql/mutations';
import { getPrizesForConfig } from '../../../graphql/queries';

import './Notifications.css';


interface NotificationProps {
    config: { [key: string]: any };
    setNotificationState: Dispatch<SetStateAction<notificationType>>;
    handleTabChange: Dispatch<SetStateAction<boolean>>;
}

const getInitialValues = (config: { [key: string]: any }) => ({
    configuration_id: config.configurationId || "",
    active: false,
    notification_emails: [],
    module_id: "default"
});


const Notifications = ({ config, setNotificationState, handleTabChange }: NotificationProps,) => {

    const [initialState, setInitialState] = useState(() => getInitialValues(config) );
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [disabledVoucher, setDisabled] = useState<boolean>(false);
    let urlParams = useParams();

    const retrieveVouchersNotif = useCallback( async () => {
        try {
            const queryResult: any = await API.graphql({
                query: getVoucherNotification,
                variables: { configuration_id: config.configurationId, module_id: 'default' },
            });

            const vouchersInfo = queryResult.data.getVoucherNotification.items;

            if (vouchersInfo.length > 0) {
                setInitialState((prevState) => ({
                    ...prevState,
                    notification_emails: vouchersInfo[0].notification_emails,
                    active: vouchersInfo[0].active,
                }));

                setIsEdit(true);
            }
        } catch (e) {
            
            console.error('Error while retrieving vouchers info', e);
            
        }
    }, [config.configurationId]);

    useEffect(() => {
       const getPrizes = async () => {
                   const queryResult: any = await API.graphql({
                       query: getPrizesForConfig,
                       variables: { configuration_id: urlParams.promotionId },
                   });
                   const prizesForConfig = queryResult?.data?.getPrizesForConfig?.items || [];

                   setDisabled(prizesForConfig.length === 0);
               };

        retrieveVouchersNotif();
        getPrizes();

    }, [retrieveVouchersNotif, urlParams]);


    return (

        <Box className='notif-main-box'>
            <Box className='notif-tap-wrapper'>
                <Typography variant='h3'>Notifications</Typography>
                <Typography variant='h5' className='voucher-text'>
                    Voucher Notifcations
                </Typography>
            </Box>
            <Formik
                initialValues={initialState}
                enableReinitialize

                onSubmit={async (values: any, { resetForm }) => {

                    const data = {
                        "configuration_id": values.configuration_id,
                        "active": values.active,
                        "notification_emails": !values.active ? [] : values.notification_emails,
                        "module_id": values.module_id
                    }
                    try {

                        if(values.active && values.notification_emails.length === 0){
                            setNotificationState({
                                open: true,
                                title: 'Error',
                                content: 'Please Provide at least one email address',
                                level: 'error',
                            });

                            return;
                        }

                        
                        if (isEdit) {
                            await API.graphql(graphqlOperation(updateVoucherNotificationTable, { input: data }));
                        } else {
                            await API.graphql(graphqlOperation(createVoucherNotificationTable, { input: data }));
                        }
                        
                        setInitialState(values)
            
                        setNotificationState({
                            open: true,
                            title: 'Promotion updated successfully',
                            content: 'Promotion Changes were saved!',
                            level: 'success',
                        });

                        setIsEdit(false)
                        resetForm({ values });
                        await retrieveVouchersNotif();

                    } catch (e) {
                        setNotificationState({
                            open: true,
                            title: 'Error',
                            content: 'Promotion update request failed!',
                            level: 'error',
                        });
                        console.error(e);
                    }
                }}> 
                <Form>
                    <NotificationInner handleTabChange={handleTabChange} disabledCheckbox={disabledVoucher}/>
                </Form>
            </Formik>
        </Box>
            
    );
};

export { Notifications };
